import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
  data: {
    ofertas: undefined,
    //tiposOferta: undefined,
    ofertaSelected: undefined,
    oferta: undefined,
  },
})

export default function ofertaReducer(state = initialState, action) {
  if (action.type === ReducerActions.SET_OFERTAS) {
    return state.setIn(['data', 'ofertas'], action.payload)
  }

  if (action.type === ReducerActions.SET_OFERTA_SELECTED) {
    return state.setIn(['data', 'ofertaSelected'], action.payload)
  }

  if (action.type === ReducerActions.SET_OFERTA_INACTIVO) {
    let myState = state.toJS()

    let ofertas = myState.data.ofertas

    ofertas = ofertas.filter((o) => {
      return o.idOferta !== action.payload
    })

    return state.setIn(['data', 'ofertas'], ofertas)
  }

  if (action.type === ReducerActions.SET_OFERTABYID) {
    return state.setIn(['data', 'oferta'], action.payload)
  }

  return state
}
